import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EventResponse} from "../../../model/response/event/event-response.model";
import {ConstantsEnum} from "../../../enums/constants-enum";

@Component({
    selector: 'app-event-detail-info-modal',
    templateUrl: './event-detail-info-modal.component.html',
    standalone: false
})
export class EventDetailInfoModalComponent implements OnInit {

  @Input('event') event: EventResponse

  notInformedText = ConstantsEnum.NOT_INFORMED

  @Input('display') displayModal: boolean
  @Output('onCancelModal') onCancelModalEmitter = new EventEmitter()

  constructor() {
  }

  ngOnInit(): void {
  }
}
